/**
 * Bestätigen per Sprache (Vorgabe Kevin, 25.09.2026): ausgeführt wird erst auf „Ja, anlegen" —
 * ein nacktes „Ja" oder „Okay" reicht nicht, und ein Satz mit „aber" ist eine Änderung, keine
 * Zusage. Im Zweifel `null`: dann geht der Satz als Nachricht an KIAN, und nichts wird ausgeführt.
 */

export type ConfirmIntent = 'confirm' | 'reject' | null;

const DO_IT =
  /\b(anlegen|anleg|ausführen|ausfuehren|schließen|schliessen|speichern|übernehmen|uebernehmen|abschicken|umsetzen|erledigen)\b/;

export function normalizeUtterance(text: string): string {
  return text
    .toLowerCase()
    .replace(/[.,!?;:„"“”'()]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function classifyConfirmation(transcript: string): ConfirmIntent {
  const t = normalizeUtterance(transcript);
  if (!t) return null;
  const words = t.split(' ');

  // Ablehnung zuerst: „Nein, nicht anlegen" darf nie als Zusage gelten
  if (/^(nein|stopp|stop|abbrechen|verwerfen|lass es|lass das|lieber nicht|doch nicht)\b/.test(t)) return 'reject';
  if (/\bnicht (anlegen|ausführen|ausfuehren|schließen|schliessen|speichern)\b/.test(t)) return 'reject';

  // Zusage nur kurz und eindeutig: beginnt mit Ja/Okay/Genau, nennt die Handlung, kein „aber"
  if (words.length > 6) return null;
  if (/\b(aber|nur|statt|sondern|vorher|ändere|aendere|änder)\b/.test(t)) return null;
  if (/^(ja|jawohl|okay|ok|genau|passt|gut)\b/.test(t) && DO_IT.test(t)) return 'confirm';
  return null;
}
